export default "__VITE_ASSET__QrVDVHWa__"